import "./blocks/_notifications";
import ProductVariations from "./blocks/_product";
import ShopTheLook from "./blocks/_shop-the-look";
import InitWhishlist from "./blocks/_whishlist";

if ( document.querySelector( '.hero__swiper' ) ) {
	let heroSwiper = new Swiper( '.hero__swiper', {
		autoplay: {
			delay: 5000
		},
		slideClass: 'hero__slide',
		slideActiveClass: 'hero__slide--active',
		pagination: {
			el: '.hero__pagination',
			type: 'bullets',
			clickable: true,
			bulletClass: 'hero__bullet',
			bulletActiveClass: 'hero__bullet--active'
		},
		loop: true
	});
}

if ( document.querySelector( '.hero__swiper-mobile' ) ) {
	let heroSwiperMobile = new Swiper( '.hero__swiper-mobile', {
		autoplay: {
			delay: 5000
		},
		slideClass: 'hero__slide-mobile',
		slideActiveClass: 'hero__slide--active-mobile'
	});
}

if ( document.querySelector( '.shop-the-look__swiper' ) ) {
	let shopTheLookSwiperMobile = new Swiper( '.shop-the-look__swiper', {
		slidesPerView: 3,
		spaceBetween: 6,
		navigation: {
			prevEl: '.shop-the-look__button--prev',
			nextEl: '.shop-the-look__button--next'
		},
		breakpoints: {
			991: {
				spaceBetween: 20
			}
		}
	});
}

if ( document.querySelector( '.banner__swiper' ) ) {
	let bannerSwiper = new Swiper( '.banner__swiper', {
		slideClass: 'banner__slide',
		slideActiveClass: 'banner__slide--active',
		navigation: {
			nextEl: '.banner__button--prev',
			prevEl: '.banner__button--next'
		},
		slidesPerView: 2,
		spaceBetween: 20,
		breakpoints: {
			991: {
				slidesPerView: 1,
				spaceBetween: 0
			},
			1200: {
				slidesPerView: 2,
				spaceBetween: 0
			},
			1800: {
				slidesPerView: 3,
				spaceBetween: 0
			}
		}
	});
}

if ( document.querySelector( '.video__swiper' ) ) {
	let videoSwiper = new Swiper( '.video__swiper', {
		slideClass: 'video__slide',
		slideActiveClass: 'video__slide--active',
		navigation: {
			prevEl: '.video__button--prev',
			nextEl: '.video__button--next'
		},
		spaceBetween: 26,
		slidesPerView: 1,
		breakpoints: {
			576: {
				slidesPerView: 2
			},
			1200: {
				slidesPerView: 3
			}
		}
	});
}

if ( document.querySelector( '.blog__swiper' ) ) {
	let blogSwiper = new Swiper( '.blog__swiper', {
		pagination: {
			el: '.blog__pagination',
			type: 'fraction',
			renderFraction: function( currentClass, totalClass ) {
				return '<span class="blog__pagination--total ' + totalClass + '"></span>' +
					' | ' +
					'<span class="blog__pagination--current ' + currentClass + '"></span>';
			}
		},
		navigation: {
			nextEl: '.blog__button--next',
			prevEl: '.blog__button--prev'
		}
	});
}

setTimeout( () => {
	let footerDropdown = document.querySelectorAll( '.nav-footer ul:not([class*="nav-footer__single"]) li:first-child' );
	footerDropdown.forEach( function( el ) {
		el.addEventListener( 'click', function(event) {
			if ( 768 >= window.innerWidth ) {
				event.preventDefault();
				this.parentNode.classList.toggle( 'nav-footer__list--active' );
			}
		});
	});

	let searchFormButton = document.querySelector( '.search-form__submit--mobile' );
	searchFormButton.addEventListener( 'click', function() {
		if ( 1200 >= window.innerWidth ) {
			event.preventDefault();
			this.nextElementSibling.classList.toggle( 'search-form__field--active' );
		}
	});

	let headerBurger = document.querySelector( '.header__burger' ),
		headerNav = document.querySelector( '.header__bottom' );
	headerBurger.addEventListener( 'click', function() {
		headerNav.classList.toggle( 'header__bottom--active' );
	});

	let headerNavDropdown = document.querySelectorAll( '#menu-header .menu-item-has-children>a' );
	headerNavDropdown.forEach( function( el ) {
		el.addEventListener( 'click', function() {
			if ( 1200 >= window.innerWidth ) {
				event.preventDefault();
				this.parentNode.classList.toggle( 'menu-item-has-children--active' );
			}
		});
	});
}, 1000 );

if ( document.querySelector( '.information' ) ) {
	let information = document.querySelectorAll( '.information__item' );
	let last = information[ 0 ];
	let heads = document.querySelector( '.information' ).querySelectorAll( '.information__head' );
	let bodys = document.querySelector( '.information' ).querySelectorAll( '.information__body' );
	information.forEach( function( el ) {
		el.addEventListener( 'click', function() {
			heads.forEach( function( elem ) {
				elem.classList.remove( 'information__head--active' );
			});
			bodys.forEach( function( elem ) {
				jQuery( elem ).slideUp();
				elem.classList.remove( 'information__body--active' );
			});
			if ( el !== last || ! el.classList.contains( 'information__item--active' ) ) {
				let head = this.querySelector( '.information__head' );
				let body = this.querySelector( '.information__body' );
				head.classList.toggle( 'information__head--active' );
				body.classList.toggle( 'information__body--active' );
				jQuery( body ).slideDown();
			}
			el.classList.toggle( 'information__item--active' );
			last = el;
		});
	});
}

if ( document.querySelector( '.tabs' ) ) {
	let tabs = document.querySelectorAll( '.tabs__header' );
	tabs.forEach( function( el ) {
		el.addEventListener( 'click', function() {
			if ( 768 >= window.innerWidth ) {
				this.classList.toggle( 'tabs__header--active' );
				this.nextElementSibling.classList.toggle( 'tabs__content--active' );
			}
		});
	});
}

jQuery( document ).ready( function( $ ) {
	function wishlistUpdateCount() {
		var counter = $( '.header__wishlist-count' );

		$.ajax({
			url: yith_wcwl_l10n.ajax_url,
			data: {
				action: 'yith_wcwl_update_wishlist_count'
			},
			dataType: 'json',
			success: function( data ) {
				counter.html( data.count );
				if ( 0 == data.count ) {
					counter.css( 'display', 'none' );
				} else {
					counter.css( 'display', 'flex' );
				}
			}
		});
	};
	wishlistUpdateCount();
	$( document ).on( 'added_to_wishlist removed_from_wishlist', wishlistUpdateCount );

	$( document ).on( 'added_to_wishlist', function() {
		if (typeof dataLayer !== 'undefined') {
			dataLayer.push({
				'event': 'add_to_wishlist'
			});
		}
	} );

	if ( document.querySelector( '.category-page' ) ) {
		let inst = $( '.price-levels' ).remodal();
		if ( ! localStorage.getItem( 'priceLevel' ) ) {
			inst.open();
			localStorage.setItem( 'priceLevel', 1 );
		}
	}

	if (document.querySelector('.shop-the-look-page__swiper')) {
		let shopTheLookPageSwiper = new Swiper( '.shop-the-look-page__swiper', {
			slideClass: 'shop-the-look-page__slide',
			slideActiveClass: 'shop-the-look-page__slide--active',
			navigation: {
				nextEl: '.shop-the-look-page__button--prev',
				prevEl: '.shop-the-look-page__button--next'
			},
			spaceBetween: 24,
			slidesPerView: 2
		});
	}

	if ( document.querySelector( '.minicart__product__remove' ) ) {
		$('.js-minicart').on( 'click', '.minicart__product__remove', function( event ) {
			event.preventDefault();
			event.stopPropagation();
			var current_qty = parseInt($(this).attr('data-in-cart-qty'));
			var id = $(this).attr('data-product_id');
			var cat_item_key = $(this).attr('data-cart_item_key');
			var data = {
				product_id: id,
				quantity: current_qty - 1,
				cat_item_key : cat_item_key
			};
			var url = wc_add_to_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'rgbc_update_qty');
			$.ajax({
				url: url,
				data: data,
				type: 'POST'
			}).done(function (response) {
				if (!response) {
					return;
				}
				if (response) {
					jQuery(document.body).trigger('wc_fragment_refresh');
					// location.reload();
				}
			});
		} );
	}

	if (document.querySelector('.woocommerce-checkout') || document.querySelector('.woocommerce-cart')) {
		let datesArr = [];
		let variation_ids = [];

		function MakeVariations() {
			let table = document.querySelector('.cart__discount__table');
			let variations = table.querySelectorAll('[data-variation]');

			variation_ids = [];

			variations.forEach(el => {
				if (variation_ids[el.dataset.variation.toString()]) {
					variation_ids[el.dataset.variation.toString()]++;
				}
				else {
					variation_ids[el.dataset.variation.toString()] = 1;
				}
			});

			for (const key in variation_ids) {
				if (variation_ids.hasOwnProperty(key)) {
					const element = variation_ids[key];
					UpdateProductStock(key, element);
				}
			}
		}

		MakeVariations();

		function UpdateProductStock( variation_id, stock ) {
			datesArr = [];
			jQuery.ajax({
				url: kaza_ajax.url,
				data: {
					action: 'update_product_stock',
					nonce_code: kaza_ajax.nonce,
					variation: variation_id
				},
				type: 'POST',
				success: function( ) {
					// KZ-356
					change_order_total();
					$('.checkout-details-total').css('display', 'block');

					let shippingCart = $('input[name="shipping_method[0]"]:checked').val();
					let shippingCheckout = $('#agree-too-pay').val();
					let shipping = shippingCart === 'flat_rate:4' || shippingCheckout === '1' ? 'yes' : 'no';
					CheckStock( variation_id, stock, shipping );
				}
			});
		};

		function CheckStock( variation_id, stock, shipping ) {
			jQuery.ajax({
				url: kaza_ajax.url,
				data: {
					action: 'kaza_check_product_stock',
					nonce_code: kaza_ajax.nonce,
					variation: variation_id,
					shipping: shipping,
					stock: stock
				},
				type: 'POST',
				success: function( res ) {
					if ( ! res.success ) {
						return;
					}

					const data = res.data;

					// If server sent custom_availability -> hand it to SetArrivalDate directly
					if ( data && data.custom_availability ) {
						// pass empty array and the custom string
						SetArrivalDate([], data.custom_availability);
						return;
					}

					// get date string (supporting either res.data as string or object with stock_by_date)
					let dateStr = '';
					if ( typeof data === 'string' ) {
						dateStr = data;
					} else if ( data && typeof data.stock_by_date === 'string' ) {
						dateStr = data.stock_by_date;
					}

					if ( ! dateStr ) {
						// no date -> clear / hide
						SetArrivalDate([]);
						return;
					}

					// normalize (allow YYYY-MM-DD or DD-MM-YYYY or with slashes)
					dateStr = dateStr.trim().replace(/\//g, '-');
					const parts = dateStr.split('-').map(p => p.trim());
					if ( parts.length !== 3 ) {
						SetArrivalDate([]);
						return;
					}

					let day, month, year;
					if ( parts[0].length === 4 ) { // YYYY-MM-DD
						year  = parseInt(parts[0], 10);
						month = parseInt(parts[1], 10);
						day   = parseInt(parts[2], 10);
					} else { // assume DD-MM-YYYY
						day   = parseInt(parts[0], 10);
						month = parseInt(parts[1], 10);
						year  = parseInt(parts[2], 10);
					}

					if ( isNaN(day) || isNaN(month) || isNaN(year) ) {
						SetArrivalDate([]);
						return;
					}

					const parsed = new Date(year, month - 1, day);
					if ( isNaN(parsed.getTime()) ) {
						SetArrivalDate([]);
						return;
					}

					// push the timestamp
					datesArr.push(parsed.getTime());
					SetArrivalDate(datesArr);
				},
			});
		}

		let arrivalDate = document.createElement('div');
		arrivalDate.style.cssText = 'color: #267d26; font-size: 14px; display: none;';

		if (document.querySelector('#order_review .pay-for-order__checkboxes')) {
			let shipping = document.querySelector('#order_review .pay-for-order__checkboxes');
			arrivalDate.style.marginBottom = '20px';
			shipping.prepend(arrivalDate);
		}

		if (document.querySelector('.cart_totals .shipping-items')) {
			let shipping = document.querySelector('.cart_totals .shipping-items');
			arrivalDate.style.marginTop = '10px';
			shipping.append(arrivalDate);
		}

		if (document.querySelector('.account-payment__payment')) {
			let shipping = document.querySelector('.account-payment__payment');
			arrivalDate.style.marginTop = '10px';
			shipping.prepend(arrivalDate);
		}

		$(document).on( 'wc_fragments_refreshed updated_shipping_method updated_checkout updated_cart_totals', function () {
			MakeVariations();
			let shipping = document.querySelector( '.cart_totals .shipping-items' );
			arrivalDate.style.marginTop = '10px';
			if ( shipping ) {
				shipping.append( arrivalDate );
			}
		});

		let timer = setTimeout(() => {

		}, 500);

		function SetArrivalDate(dArr, customAvailability='') {
			clearTimeout(timer);
			timer = setTimeout(() => {
				console.log('here', dArr, customAvailability);
				if ( typeof customAvailability === 'string' && customAvailability.length > 0 ) {
					arrivalDate.textContent = customAvailability;
					$(arrivalDate).slideDown();
					return;
				}

				if (!Array.isArray(dArr) || dArr.length === 0) {
					$(arrivalDate).slideUp();
					return;
				}

				let theMaxDate = Math.max(...dArr);
				if (!isFinite(theMaxDate)) {
					$(arrivalDate).slideUp();
					return;
				}

				let date = new Date(theMaxDate);
				if (isNaN(date.getTime())) {
					$(arrivalDate).slideUp();
					return;
				}

				let formatedMonth = ("0"+(date.getMonth()+1)).slice(-2);
				arrivalDate.textContent = `זמן אספקה משוער של כלל המוצרים שרכשת הינו בתאריך ${date.getDate()}-${formatedMonth}-${date.getFullYear()}`;
				$(arrivalDate).slideDown();
			}, 1000);
		}
	}

	if ( document.querySelector( '.shop-the-look-page' ) ) {
		new ShopTheLook();
	}

	if ( document.querySelector( '.product' ) ) {
		new ProductVariations({
			debug: false
		});
	}

	if ( document.querySelector( '.yith-wcwl-add-to-wishlist' ) ) {
		InitWhishlist();
	}

	// Defer YT videos
	function deferYt() {
		let vidDefer = document.getElementsByTagName('iframe');
		for (let i=0; i<vidDefer.length; i++) {
			if(vidDefer[i].getAttribute('data-src')) {
				vidDefer[i].setAttribute('src',vidDefer[i].getAttribute('data-src'));
			}
		}
	}
	$('.video').on('click', function(){
		deferYt();
	});

	document.querySelector('body').addEventListener('click', function (event) {
		if( event.target.classList.contains('is-form') ) {
			let quantityInput = event.target.parentNode.querySelector('.qty');
			switch (event.target.value) {
				case '+':
					if (+quantityInput.value < +quantityInput.max) {
						+quantityInput.value++;
					}
					break;
				case '-':
					if (quantityInput.value > 1) {
						+quantityInput.value--;
					}
					break;
			}
		}
	})

	//KZ-356
	function change_order_total( item = null ) {
		if ( $('.js-order-total').length > 0 && $('#club_field').length > 0 ) {
			const memberTotal = $('.js-order-total').attr('data-member-total');
			const customerTotal = $('.js-order-total').attr('data-customer-total');
			const type = item === null ? $("#club_field .input-radio:checked").val() : item.val();
			const total = type === 'member' ? memberTotal : customerTotal;

			$('.js-order-total').html(total);
		}
	}

	//KZ-356
	$('body').on('change', '#club_field .input-radio', function () {
		change_order_total($(this));
		$('.checkout-details-total').css('display', 'block');
	});

	if( $('.js-kaza-iframe').length > 0 ) {
		$('.js-kaza-iframe').each(function () {
			let dataSrc = $(this).attr('data-src');
			$(this).attr('src', dataSrc);
		});
	}

	// If there is one method, we can hide the payment options
	$('body').on('updated_checkout', function(){
		let payment_methods = $( '.woocommerce-checkout' ).find( 'input[name="payment_method"]' );
		if ( 1 === payment_methods.length ) {
			$('#payment > ul').hide();
			$('.woocommerce-checkout-review-order > p.checkout__title').hide();
		}
	});

	document.addEventListener( 'wpcf7mailsent', function( event ) {
		//KZ-401
		if ( '55' === event.detail.contactFormId ) {
			window.location = '//www.kaza.co.il/contactus-thankyou/';
		}

		//KZ-402
		if ( '474' === event.detail.contactFormId ) {
			window.location = '//www.kaza.co.il/newsletter-thankyou/';
		}
	}, false );

	let currentYear = new Date().getFullYear();
	if ($('#birthday-date').length) {
		$('#birthday-date').datepicker({
			dateFormat: 'dd/mm/yy',
			changeMonth: true,
			changeYear: true,
			constrainInput: true,
			gotoCurrent: true,
			yearRange: ( currentYear - 100 ) + ':' + ( currentYear - 10 )
		});
	}

});
